import { combineReducers, configureStore } from '@reduxjs/toolkit';
import '../index.css';
import product from './slices/product';
import cart from './slices/cart';
import user from './slices/user';
import order from './slices/order';
import admin from './slices/admin';
import search from './slices/search';
import notification from './slices/notification'
import invoice from './slices/invoice'
import { finance } from './slices/finance';
import financeSlice from './slices/financeSlice'
const reducer = combineReducers({
	product,
	cart,
	user,
	order,
	admin,
	search,
	notification,
	invoice,
	finance,
	financeSlice
});

export default configureStore({ reducer });